import React, {useState} from 'react';
import {useHistory} from 'react-router-dom'
import {Field, Form, Formik} from "formik"
import * as Yup from "yup"
import {useTranslation} from "react-i18next";
import store from "@formApp/store"
import GenericInput from "@formComponents/fields/GenericInput"
import FormRecaptcha from "@formComponents/fields/FormRecaptcha"
import LoginWith from "@formComponents/LoginWith"
import FormError from "@formComponents/FormError";

export default () => {
  let history = useHistory();
  const {t} = useTranslation();
  const {formValues, domainsList, loginWithWidget, formErrors, transitions} = React.useContext(store);

  const [visibilityUrlToImport, setVisibilityUrlToImport] = useState(false);

  const selectedItem = domainsList.getSelected();
  if (!selectedItem) history.push('step-1');
  const {data, userIsConnected} = loginWithWidget;

  let urlToImportValid = {success:false, value:''};
  Yup.addMethod(Yup.string, 'urlToImport', function (message) {
    return this
      .test({
        name: 'urlToImport',
        message: message,
        test: async function (value) {
          if (value && value.length > 0 && value != urlToImportValid.value) {
            urlToImportValid.value = value;
            const response = await fetch(`https://aa.altervista.org/cgi-bin/av_blog_import.pl?&rt=json&url=${value}`)
            const json = await response.json()
            if (json.message == 'ok') {
              urlToImportValid.success = true;
            } else {
              urlToImportValid.success = false;
            }
          }
          return urlToImportValid.success;
        }
      })
  })

  let initialValues = {
    Username: formValues.getValue('userName'),
    token: window.alterToken,
    FacebookId: '',
    FacebookAT: '',
    googleid: '',
    googletokenid: '',
    TipoAccount: accountType,
    Nome: formValues.getValue('Nome') || '',
    Cognome: formValues.getValue('Cognome') || '',
    Birth: formValues.getValue('Birth') || '',
    Email: formValues.getValue('Email') || '',
    mailConfirm: formValues.getValue('mailConfirm') || '',
    "g-recaptcha-response": '',
    Autorizzo: false,
    fullDomainName: `${formValues.getValue('userName')}.altervista.org`,
    urlToImportCheckbox: false,
    urlToImport: formValues.getValue('urlToImport') || ''
  };

  let validationSchema = {
    Username: Yup.string().required(),
    Nome: Yup.string().required(t('Devi inserire il tuo nome')),
    Cognome: Yup.string().required(t('Devi inserire il tuo cognome')),
    Birth: Yup.string().required(t('Devi inserire il tuo anno di nascita')),
    Email: Yup.string().email(t('err_Email')).required(t('Devi inserire il tuo indirizzo email')),
    mailConfirm: Yup.string().oneOf([Yup.ref('Email'), null], t('Le email non corrispondono')).required(t('Devi confermare la tua email')),
    "g-recaptcha-response": Yup.string().when('Username', {
      is: Username => !(/^prvns(\d+)[a-zA-Z0-9]*$/.test(Username)),
      then: Yup.string().required(t('Devi verificare la tua identità')),
    }),
    Autorizzo: Yup.boolean().oneOf([true], t('Devi accettare i termini e le condizioni')).required(),
    urlToImportCheckbox: Yup.boolean(),
    urlToImport: Yup.string().when('urlToImportCheckbox', {
      is: urlToImportCheckboxValue => (urlToImportCheckboxValue == true),
      then: Yup.string().required(t('Inserisci una url valido')).urlToImport(t('Url non valida')),
    })
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={Yup.object(validationSchema)}
      validateOnChange={false}
      validateOnBlur={true}
      setFieldValue
      onSubmit={ async (values, { setSubmitting }) => {
        try {
          formErrors.clear();
          formValues.set(values);

          const formEncoded = new URLSearchParams();
          formEncoded.append('rt', 'json');
          for (let field in values) {
            formEncoded.append(field, values[field]);
          }
          const res = await fetch('https://aa.altervista.org/cgi-bin/joinus5.pl', {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: formEncoded
          });
          if (!res.ok) throw new Error(res.statusText);
          const data = await res.json();
          if (data.status === 'ok') {
            transitions.setCurrent('domainSelected');
            history.push('step-confirm-av');
          } else if (data.status === 'error') {
            formErrors.addToHead(data.error_message);
            formValues.recaptchaRef.reset();
            formValues['g-recaptcha-response'] = '';
            // data.error_code è numerico, indica un messaggio di errore tipo https://aa.altervista.org/message.php?error=$err_code
            // in questi casi la registrazione può essere interrotta, il testo del messaggio già tradotto è in data.error_message, può contenere html
          } else {
            throw new Error(data);
          }
        } catch (err) {
          setSubmitting(false);
          // TODO: errore generico?
        }
      }}
    >
      {props => {
        return (
          <Form className='domainRegistration'>
            <div className='transitionWrapper'>
              <div className='toTransition'>
                <section className='formSection halfColumn'>
                  
                  <div className='domainName'>
                    <div className='formSection--title'>{t('NomeDominio')}</div>
                    <GenericInput name='domainName' label={initialValues.fullDomainName} disabled="disabled" />
                  </div>

                  {accountType === 'blog' && (
                  <Field name="aaaa">
                    {({field, form, meta: { touched, error }}) => {
                      const handleChange = (e, setFieldValue) => {
                        setVisibilityUrlToImport(e.target.checked);
                        if (e.target.checked) {
                          form.setFieldValue('urlToImportCheckbox', true) 
                        } else {
                          form.setFieldValue('urlToImportCheckbox', false);
                        }
                      };
                      return (
                        <div className={`urlToImportCheckbox formGroup${(touched && error) ? ' error' : ''}`} style={{gridColumn: '1 / span 2'}}>
                          <div className='formField --checkbox'>
                            <label>
                              <input type="checkbox" name="urlToImportCheckbox" className='form-check-input' value={true} onChange={handleChange} />
                              {t('Importa un blog che hai già')}
                            </label>
                          </div>
                          {touched && error && <div className="errorMessage">{error}</div>}
                        </div>
                      )}}
                  </Field>
                  )}

                  {visibilityUrlToImport && (
                    <>                      
                      <GenericInput name='urlToImport' label={t('Indirizzo vecchio blog')} />
                    </>
                  )}
                  
                  <div className='formSection--title'>
                    {t('Inserisci i dati personali')}
                  </div>
                  <div className='formGroup' style={{gridColumn: '1 / span 2'}}>
                    <LoginWith/>
                  </div>
                  <input type='hidden' name='TipoAccount' value='blog' />
                  <input type='hidden' name='token' value={window.alterToken} />
                  <input type='hidden' name='Username' value={formValues.getValue('userName')} />
                  <GenericInput name='Nome' label={t('Nome')} />
                  <GenericInput name='Cognome' label={t('Cognome')} />
                  <Field name="Birth">
                    {({field, meta: { touched, error }}) => {
                      const startDate = new Date().getFullYear() - 16;
                      const endDate = new Date().getFullYear() - 110;
                      const years = [];
                      for (let year = startDate; year >= endDate; year--) {
                        years.push(<option key={year} value={year}>{year}</option>)
                      }
                      return (
                        <div className={`formGroup${(touched && error) ? ' error' : ''}`}>
                          <select {...field} className='formField --select'>
                            <option value="" disabled >{t('Anno di nascita')}</option>
                            {years}
                          </select>
                          {touched && error && <div className="errorMessage">{error}</div>}
                        </div>
                      )
                    }}
                  </Field>
                  <div>&nbsp;</div>
                  <GenericInput name='Email' label={t('Email')} />
                  <GenericInput name='mailConfirm' label={t('Conferma Email')} />
                </section>
                <section className='formSection'>
                  <Field name="Autorizzo">
                    {({field, form, meta: { touched, error }}) => (
                      <div className={`formGroup${(touched && error) ? ' error' : ''}`}>
                        <div className='formField --checkbox'>
                          <div className='fieldTitle'>{t('Termini e condizioni')}</div>
                          <input type="checkbox" name={field.name} value="1" defaultChecked={field.value} onChange={field.onChange} />
                          <label dangerouslySetInnerHTML={{__html: t('altervista_tos_and_privacy')}}></label>
                        </div>
                        {touched && error && <div className="errorMessage">{error}</div>}
                      </div>
                    )}
                  </Field>
                  <div className='formGroup'>
                    <div className='fieldTitle'>{t('Conferma la tua identità')}</div>
                    <FormRecaptcha />
                  </div>
                </section>
                <FormError />
                <section className='form-bottom-actions'>
                  <button className='btn-form-default' type="submit">{t('Procedi')}</button>
                </section>
              </div>
            </div>
          </Form>
        )
      }}
    </Formik>
  )
}
